export enum SecurityWorkerMessage {
  init = <any>'init',
  logout = <any>'logout',
  login = <any>'login',
  error = <any>'error',
  subscruption = <any>'subscruption'
}
